export default "__VITE_ASSET__Ce4puloR__"